(() => {
    console.log('%c🧑‍🤝‍🧑 People', 'color: yellow');

    const sections = document.querySelectorAll('.people-section');
    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const revealTargets = section.querySelectorAll('[data-people-intro], [data-people-card]');
        if (revealTargets.length) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    const target = entry.target;
                    target.classList.remove('opacity-0', 'translate-y-12', 'translate-y-16', 'translate-y-20', 'translate-y-full');
                    target.style.willChange = 'auto';
                    obs.unobserve(target);
                });
            }, {
                root: null,
                rootMargin: '0px 0px -10% 0px',
                threshold: 0.35
            });

            revealTargets.forEach((target) => {
                const delay = target.dataset.peopleDelay;
                if (delay) {
                    target.style.transitionDelay = `${delay}ms`;
                }

                target.style.willChange = 'transform, opacity';
                observer.observe(target);
            });
        }

        const panel = section.querySelector('[data-people-panel]');
        const drawer = section.querySelector('[data-people-drawer]');
        const closeBtn = section.querySelector('[data-people-close]');
        const prevBtn = section.querySelector('[data-people-prev]');
        const nextBtn = section.querySelector('[data-people-next]');
        const sliderEl = section.querySelector('[data-people-slider]');
        const triggerSelector = '[data-people-trigger]';

        let sliderInstance = null;
        let panelCloseTimeout;
        let isOpen = false;

        const updateNav = () => {
            if (!sliderInstance) {
                if (prevBtn) prevBtn.disabled = true;
                if (nextBtn) nextBtn.disabled = true;
                return;
            }

            const rel = sliderInstance.track.details.rel;
            const maxIdx = sliderInstance.track.details.maxIdx;

            if (prevBtn) {
                prevBtn.disabled = rel === 0;
            }

            if (nextBtn) {
                nextBtn.disabled = rel === maxIdx;
            }

        };

        const ensureSlider = () => {
            if (sliderInstance || !sliderEl || typeof KeenSlider === 'undefined') {
                return;
            }

            sliderInstance = new KeenSlider(sliderEl, {
                slides: {
                    perView: 1,
                    spacing: 0
                },
                defaultAnimation: {
                    duration: 500
                },
                created: updateNav,
                slideChanged: updateNav
            });
        };

        const lockBodyScroll = (shouldLock) => {
            const body = document.body;
            if (!body) {
                return;
            }

            body.classList.toggle('overflow-hidden', shouldLock);
        };

        const openPanel = (targetIndex = 0) => {
            if (!panel || !drawer) {
                return;
            }

            ensureSlider();

            isOpen = true;
            clearTimeout(panelCloseTimeout);
            panel.classList.remove('pointer-events-none');
            panel.setAttribute('aria-hidden', 'false');
            drawer.classList.remove('translate-x-full');
            drawer.classList.add('translate-x-0');
            lockBodyScroll(true);

            if (sliderInstance) {
                sliderInstance.moveToIdx(targetIndex, true);
                updateNav();
            }
        };

        const closePanel = () => {
            if (!panel || !drawer) {
                return;
            }

            isOpen = false;
            drawer.classList.add('translate-x-full');
            drawer.classList.remove('translate-x-0');
            lockBodyScroll(false);

            panelCloseTimeout = window.setTimeout(() => {
                if (isOpen) {
                    return;
                }

                panel.classList.add('pointer-events-none');
                panel.setAttribute('aria-hidden', 'true');
            }, 400);
        };

        const triggers = section.querySelectorAll(triggerSelector);

        const handleTrigger = (trigger) => {
            const index = Number(trigger.dataset.peopleIndex || 0);
            openPanel(Number.isNaN(index) ? 0 : index);
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                handleTrigger(trigger);
            });

            trigger.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                handleTrigger(trigger);
            });
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', closePanel);
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                ensureSlider();
                if (sliderInstance) {
                    sliderInstance.prev();
                }
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                ensureSlider();
                if (sliderInstance) {
                    sliderInstance.next();
                }
            });
        }

        document.addEventListener('keydown', (event) => {
            if (!isOpen || event.key !== 'Escape') {
                return;
            }

            closePanel();
        });
    });
})();
